import { BannerSchema } from '@/components/Banner/style/Banner.styles';

export const bannerStyles: BannerSchema = {
  bannerBoxProps: {
    bg: 'alpha.500',
    borderRadius: 'base',
    border: 'none',
    gap: '3',
  },
  depositIconProps: {
    color: 'delta.500',
    boxSize: '9',
  },
};
